// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import "./styles/common.scss";
Vue.config.productionTip = false;

// liss modify 2023-11-17 删除登录流程
// import { getToken, setToken, setUserInfo } from "@/utils/auth.js"
// import { tansParams } from '@/utils/commonUtils.js';
// import { oauthLogin } from "@/api/login.js";
// 路由判断登录 根据路由配置文件的参数
// router.beforeEach((to, from, next) => {
// if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
//     const query = to.query;
//     if (to.path == '/main' && JSON.stringify(query) != "{}") {
//         const code = query.code;
//         if (code) {
//             oauthLogin({
//                 code
//             }).then(res => {
//                 setToken(res.token);
//                 setUserInfo(res.user.userId || "");
//                 next('/');
//             })
//         } else {
//             const isLogin = !(getToken() == "" || getToken() == undefined);
//             if (isLogin) {
//                 next();
//             } else {
//                 console.log("未登录")
//                 location.replace(`${appConfig.SSOLoginUrl}`);
//             }
//         }
//     } else {
//         const isLogin = !(getToken() == "" || getToken() == undefined);
//         if (isLogin) {
//             next();
//         } else {
//             console.log("未登录")
//             location.replace(`${appConfig.SSOLoginUrl}`);
//         }
//     }
// } else {
// next();
// }
// });
// end
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js